module.exports = {
  "country": "UK",
  "artist": "Bucks Fizz",
  "song": "Making Your Mind Up",
  "year": "1981",
  "place": "1",
  "spotify": "0i4U1Sd2R7MtEKSAHc9i8b"
};